var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 2H12C6.486 2 2 6.486 2 12V28C2 32.828 5.442 36.868 10 37.798V44C10 44.738 10.406 45.416 11.056 45.764C11.352 45.922 11.676 46 12 46C12.388 46 12.774 45.886 13.11 45.664L24.606 38H36C41.514 38 46 33.514 46 28V12C46 6.486 41.514 2 36 2ZM22.89 34.336L14 40.262V36C14 34.896 13.104 34 12 34C8.692 34 6 31.308 6 28V12C6 8.692 8.692 6 12 6H36C39.308 6 42 8.692 42 12V28C42 31.308 39.308 34 36 34H24C23.86 33.998 23.66 34.012 23.432 34.08C23.192 34.15 23.01 34.254 22.89 34.336Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 14H12C10.896 14 10 14.896 10 16C10 17.104 10.896 18 12 18H36C37.104 18 38 17.104 38 16C38 14.896 37.104 14 36 14Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 22H16C14.896 22 14 22.896 14 24C14 25.104 14.896 26 16 26H32C33.104 26 34 25.104 34 24C34 22.896 33.104 22 32 22Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.fb61346b00181d26a8839c617403e509.svg";
export { ForwardRef as ReactComponent };